



















































import { Vue, Prop, Component } from "vue-property-decorator";
import TableActions from "@/components/form/TableActions.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { documentGeneratorApi } from "@/getinfo-api";
import { TemplateFile as ITemplateFile } from "@/api-v2/document-generator/models/template-file";
import {
  TemplateFileEdit as ITemplateFileEdit,
  TemplateFileEditContextEnum
} from "@/api-v2/document-generator/models/template-file-edit";
import DocTemplateFormV2 from "@/components/doc-tempates/DocTemplateFormV2.vue";
import { TemplateFileCreate as ITemplateFileCreate } from "@/api-v2/document-generator/models";

@Component({
  components: {
    CustomTableCol,
    CustomTableItem,
    TableActions,
    DocTemplateFormV2
  }
})
export default class DocTemplateListItem extends Vue {
  @Prop() template!: ITemplateFile;
  isLoading: boolean = false;
  isShowForm: boolean = false;
  title: string = this.template.title;
  context: string = this.template.context;
  uniqId: string =
    "id" +
    Math.random()
      .toString(16)
      .slice(2);

  get translateContext() {
    let context;
    if (this.template.context === "contract")
      context = this.$tc(this.$translate.Contract);
    else if (this.template.context === "bill")
      context = this.$tc(this.$translate.Account);
    else if (this.template.context === "act")
      context = this.$tc(this.$translate.CertificateOfCompletedWorks);
    else if (this.template.context === "enrollment-order")
      context = this.$tc(this.$translate.OrderOfEnrollment);
    else if (this.template.context === "expulsion-order")
      context = this.$tc(this.$translate.OrderOfCompletion);
    else if (this.template.context === "education-protocol")
      context = this.$tc(this.$translate.TrainingProtocol);
    else if (this.template.context === "final-document")
      context = this.$tc(this.$translate.FinalDocument);

    return context;
  }

  showEditForm() {
    this.isShowForm = !this.isShowForm;
  }

  async editTemplate() {
    try {
      this.isLoading = true;
      const params: ITemplateFileEdit = {
        context: this.context as TemplateFileEditContextEnum,
        title: this.title
      };
      const {
        data
      } = await documentGeneratorApi.TemplateFiles.editTemplateFile(
        this.template.id,
        params
      );
      this.$emit("onUpdate", data);
      this.isShowForm = false;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  _editTemplate(template: ITemplateFileCreate) {
    if (template.fileId !== this.template?.fileId) {
      this.reCreateTemplate(template);
    } else {
      this.context = template.context;
      this.title = template.title;
      this.editTemplate();
    }
  }

  async reCreateTemplate(template: ITemplateFileCreate) {
    try {
      this.isLoading = true;
      await documentGeneratorApi.TemplateFiles.deleteTemplateFile(
        this.template.id
      );
      const {
        data
      } = await documentGeneratorApi.TemplateFiles.createTemplateFile(template);
      await this.$emit("onReCreate", {
        id: this.template.id,
        newTemplate: data
      });
      await this.$store.dispatch("successToast", {
        message: `${this.$tc(this.$translate.Successful)}`
      });
      this.isShowForm = false;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async deleteTemplate() {
    try {
      this.isLoading = true;
      const response = await documentGeneratorApi.TemplateFiles.deleteTemplateFile(
        this.template.id
      );
      if (response.status === 204) {
        this.$emit("onDelete", this.template.id);
      }
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }
}
